export const STRINGS = {
  MEMORY_HEADER: "Memory",
  MEMORY_DESC:
    "Manage your AI's knowledge base by adding websites, PDFs, or manual notes.",

  // Options
  SCRAPING_TITLE: "Learn from a Website",
  SCRAPING_DESC:
    "Import content from your company website to build your AI knowledge base.",
  PDF_TITLE: "PDF Document Upload",
  PDF_DESC:
    "Upload PDF documents to add structured information to your knowledge base.",
  MANUAL_TITLE: "Manual Knowledge Entry",
  MANUAL_DESC:
    "Manually enter key company or product details to expand your knowledge base.",

  // Add More Knowledge Labels
  SCRAPING_TITLE_ADD: "Add Knowledge from Website",
  SCRAPING_DESC_ADD:
    "Expand your knowledge base with additional content from a website.",
  PDF_TITLE_ADD: "Add Knowledge from PDF",
  PDF_DESC_ADD:
    "Upload more PDF documents to further enrich your knowledge base.",
  // MANUAL_TITLE_ADD: "Add Manual Knowledge",
  MANUAL_TITLE_ADD: "Add More Information",
  MANUAL_DESC_ADD:
    "Manually add more specific details to your company's knowledge profile.",

  // Modals
  WEBSITE_URL: "Website URL",
  URL_PLACEHOLDER: "Enter website URL here...",
  SELECT_FILE: "Select file",
  UPLOAD_PDF_HEADER: "PDF Document Upload",
  SCRAPE_WEBSITE_HEADER: "Learn from a Website",
  MANUAL_WRITING_HEADER: "Manual Knowledge Entry",
  MANUAL_MODAL_SUBTITLE:
    "Manually enter key company or product details to expand your knowledge base.",
  PREVIEW_MODAL_SUBTITLE:
    "Review and edit the knowledge base generated by our AI.",
  GENERATION_STATUS_TITLE: "Latest Generation Result",
  DELETE_MODAL_TITLE: "Delete Knowledge",
  DELETE_MODAL_SUBTITLE:
    "Are you sure you want to delete this knowledge? This action cannot be undone.",

  // Summary
  SUMMARY_HEADER: "Knowledge Summary",
  NO_SUMMARY: "No knowledge added yet. Start by choosing an option above.",
  NO_GROUNDED_SUMMARY: "No grounded summary was generated from this source.",
  NO_GROUNDED_SUMMARY_HELPER:
    "Upload a PDF or add company details manually to generate a grounded summary you can save.",

  // Buttons
  SAVE: "Save",
  CANCEL: "Cancel",
  EDIT: "Edit",
  DELETE: "Delete",
  UPLOAD: "Upload",
  GENERATING: "Our AI is analyzing the company...",
  GENERATE: "Generate",
  SUMMARY_PREVIEW: "Summary Preview",
  ADD_MORE: "Add more Knowledge",
  BACK_TO_PREVIEW: "Back to Preview",
  UPDATE_EXPAND: "Update & Expand",

  // Labels
  URL: "URL",
  FILE_NAME: "File Name",
  CONTENT: "Content",
  ACTION: "Action",
  CONFIDENCE_LABEL: "Confidence",
  GROUNDED_LABEL: "Grounded",
  NOT_GROUNDED_LABEL: "Not grounded",
  SOURCE_LABEL: "Source",

  // Empty Screen Data
  EMPTY_DATA: {
    create: "No Knowledge Added Yet",
    content:
      "Start building your company knowledge base by importing website content, uploading PDFs, or adding details manually.",
    body: [
      "We’ll use this information to better understand your business and generate more accurate, personalized emails.",
    ],
    foot: "Add Knowledge",
  },
};
